import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Designation } from '../../models/designation';
import { DesignationService } from '../../services/designation.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { DesignationLevelService } from '../../services/designationlevel.service';
import { DesignationLevel } from '../../models/designationlevel';

@Component({
  selector: 'app-designation',
  templateUrl: './designation.component.html',
  styleUrls: ['./designation.component.css']
})
export class DesignationComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDesignation: PageHeader;
  entity: Designation = new Designation();
  editingEntity: Designation = new Designation();
  selectedDesignation: Designation = new Designation();
  designations: any;
  designationColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  designationlevel: Array<DesignationLevel> = [];
  selectedDesignationLevel: any;
  opened: boolean = false;
  details: any;

  constructor(
    private _designationService: DesignationService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _designationLevelService: DesignationLevelService,
  ) {
    this.headerDesignation = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.designations = [];
    this.getAllDesignations();
  }
    ngAfterViewInit(): void {
    this.designationColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 60 },
      { field: "DesignationName", title: 'Designation', filter: true, sortable: true, width: 200 },
      { field: "Code", title: 'Code', filter: true, sortable: true , width: 100},
      // { field: "DesignationLevelName", title: 'Designation Level', filter: true, sortable: true },
      { field: "Active", title: 'Active', filter: false, sortable: true , width: 200},
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._designationService.getAllDesignation('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Designation>) => {
      this.designations = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllDesignationLevels(filter: string) {
    this._designationLevelService.getAllDesignationLevel(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<DesignationLevel>) => {
      this.designationlevel = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._designationService.getAllDesignation(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((designations: Array<Designation>) => {
        this.designations = {
          data: designations,
          total: designations[0] ? designations[0].TotalCount : 0
        }
      });
    }
  }
  getAllDesignations() {
    this._designationService.getAllDesignation('', Number(this.defaultPageSize), 1, 0, 0).subscribe((designations: Array<Designation>) => {
      this.designations = {
        data: designations,
        total: designations[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._designationService.deleteDesignation(this.selectedDesignation.Designation_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDesignation();
            this.getAllDesignations();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerDesignation = new PageHeader();
    headerDesignation.PageCaption = "Designation";
    headerDesignation.IconClass = "bi bi-building";
    return headerDesignation;
  }

  deleteDesignation(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDesignation.Designation_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Designation",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDesignation(event: any) {
    this.listView = false;
    this.clearDesignation();
    this.getAllDesignationLevels('');
    this.formCaption = "Add Designation";
  }

  editDesignation(event: any): void {
    if (event.seletedRows[0]) {
      this._designationService.viewDesignation(event.seletedRows[0]).subscribe((designations: Array<Designation>) => {
        let editDesignation = designations[0] ? designations[0] : new Designation();
        if (editDesignation) {
          this.editingEntity = editDesignation;
          this.selectedDesignationLevel = { Designation_Level_Id: editDesignation.Designation_Level_Id, DesignationLevelName: editDesignation.DesignationLevelName };
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.getAllDesignationLevels('');
          this.formCaption = "Edit Designation";
          this.entity.EntityMetaData = [
            { FieldName: 'DesignationName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Name is required' },
            //{ FieldName: 'Designation_Level_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Level is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
     
    if(parseInt(this.entity.Code)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }

    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._designationService.checkDuplication(this.entity.DesignationName, this.entity.Designation_Id,this.entity.Code).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Designation already exists');
          this.saveDisabled = false;
        }
        else {
          this._designationService.saveDesignation(this.entity).subscribe(() => {
            if (this.entity.Designation_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              

              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearDesignation();
            this.getAllDesignations();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }
  gotoBack(): void {
    this.listView = true;
    this.clearDesignation();
  }
  refreshDesignation(event: any): void {
    this.designations=[];
    this.getAllDesignations();
  }
  clearDesignation(): void {
    this.entity = new Designation();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Designation_Id=dataItem.Designation_Id;
 this.details =[];
  this._designationService.viewDesignation(this.entity.Designation_Id).subscribe((designations: Array<Designation>) => {
  this.opened = true;
   this.details = designations[0];
   });
}
}
